/*
 * @Description:本期价格超阈值计算
 * @Author: ningjz
 * @Date: 2024-10-12 11:12:09
 * @LastEditTime: 2026-06-08 14:30:53
 */
export default function rulesInfoDeal(row) {
  let isWarn = false; //是否告警
  let warnMsg = ''; //告警信息

  const bq = parseFloat(row.ThisPrice); //本期价格
  const dataType = row.dataType;
  const unit = row.UnitName; //单位

  let shq = parseFloat(row.ringPrice); //上环期价格
  shq = isNaN(shq) ? 0 : shq;

  const hbU = row.hbzks && parseFloat(row.hbzks); //环比上升阈值
  const hbD = row.hbjks && parseFloat(row.hbjks); //环比下降阈值
  if (dataType != '1003' && bq == 0) {
    isWarn = true;
    warnMsg = '当期价格为0，请填写原因！';
  }

  if ((dataType != '1003' && !isNaN(parseFloat(hbU))) || !isNaN(parseFloat(hbD))) {
    if (shq > 0 && bq != shq && !isWarn) {
      // 环比计算
      let rate1 = ((bq - shq) / shq) * 100;
      if (rate1 && rate1 !== 'Infinity') {
        rate1 = rate1.toFixed(1);
        if (hbU && rate1 > 0 && parseFloat(rate1) > hbU) {
          // 同比上涨超阈值
          isWarn = true;
          warnMsg = `价格环比上涨阈值为${hbU}%，当前价格环比上涨${rate1}%，请填写原因！`;
        }
        if (hbD && rate1 < 0 && parseFloat(Math.abs(rate1)) > hbD) {
          // 同比下降超阈值
          isWarn = true;
          warnMsg = `价格环比下降阈值为${hbD}%，当前价格环比下降${rate1}%，请填写原因！`;
        }
      }
    }
  }
  return { isWarn, warnMsg };
}
